import { useContext } from 'react';
import { WizardContext, WizardContextProps } from './contexts';

const useWizard = (): WizardContextProps => {
  return useContext(WizardContext) as WizardContextProps;
};

export { useWizard };
